import { render, staticRenderFns } from "./DiscoverCard.vue?vue&type=template&id=25f77540"
import script from "./DiscoverCard.vue?vue&type=script&lang=js"
export * from "./DiscoverCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports